import PointsMaterial from './ShaderEntryPoints/PointsMaterial'
import MeshPhongMaterial from './ShaderEntryPoints/MeshPhongMaterial'

export default {
    PointsMaterial,
    MeshPhongMaterial
}